export enum UserAccountTypesEnum {
  INTERNAL = 'INTERNAL',
  COMMON = 'COMMON',
}
